/**
 * convert a hex string to an object with rgba values. the alpha value will always be 100% opaque (255)
 *
 * @param hexString - i.e. '#ff0000', 'ff0000', '#f00', 'f00'
 */
const hexToRgbaObject = ( hexString: string ) =>
{
	const [, short, long]    = String( hexString ).match( /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i ) || [];
	let value: number | null = null;
	let rgbArray: number[]   = [];

	if (long) {

		value    = Number.parseInt( long, 16 );
		rgbArray = [value >> 16, value >> 8 & 0xFF, value & 0xFF];

	} else if (short) {

		rgbArray = Array.from( short, ( s ) =>
		{
			return Number.parseInt( s, 16 );
		} ).map( n => (n << 4) | n );
	}

	return {
		r: rgbArray[0],
		g: rgbArray[1],
		b: rgbArray[2],
		a: 255
	};
};


/**
 *
 */
export {hexToRgbaObject};